export default {"src":"/_next/static/media/right-arrow-disabled.7d4bd102.svg","height":17,"width":10};